import { useEffect, useRef } from 'preact/hooks';

const KEYS = ['Digit1', 'Digit2', 'Digit3'];

/** Raccourcis chiffrés 1 à 3 d'un panneau de choix : actifs seulement quand `active` est vrai. */
export function useHotkeys(active: boolean, onIndex: (i: number) => void): void {
  const handler = useRef(onIndex);
  handler.current = onIndex;
  useEffect(() => {
    if (!active) return undefined;
    const onKey = (e: KeyboardEvent): void => {
      if (e.repeat || e.ctrlKey || e.metaKey || e.altKey) return;
      const i = KEYS.indexOf(e.code);
      if (i >= 0) handler.current(i);
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [active]);
}
